/** @internal */
export const OP_DONE = "Done";
/** @internal */
export const OP_INTERRUPTED = "Interrupted";
/** @internal */
export const OP_RUNNING = "Running";
//# sourceMappingURL=stmState.js.map